export const SET_ANNUAL_MATH_LIST_EDIT = 'SET_ANNUAL_MATH_LIST_EDIT';
export const ANNUAL_MATH_LIST_EDIT = 'ANNUAL_MATH_LIST_EDIT';
export const SET_ANNUAL_MATH_LIST_ADD = 'SET_ANNUAL_MATH_LIST_ADD';
export const ANNUAL_MATH_LIST_SAVE = 'ANNUAL_MATH_LIST_SAVE';
export const SET_SELECTED_TOPIC = 'SET_SELECTED_TOPIC';
